import * as React from 'react';
import { Box, Divider, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from '@mui/material/Button';
import { DialogBox, DialogBoxContent, DialogBoxTitle } from "../ui/DialogBox";
import { PrimaryButton } from './Button';
import SuccessIcon from "../../assets/icons/notification/success.png";
import ErrorIcon from "../../assets/icons/notification/error.png";
import { ReactComponent as LockIcon } from "../../assets/icons/status-popup/lock.svg";
import InfoIcon from "../../assets/icons/notification/info.png";
import WarningIcon from "../../assets/icons/notification/waring.png";


interface ConfirmDialogProps {
    type: string;
    title: string;
    content: string;
    open: boolean;
    onClose: () => void;
    onAgree: () => void;
    onDisagree: () => void;
}

export default function ConfirmModalDelete(props: ConfirmDialogProps) {
    const { title, content, open, onClose, onAgree, onDisagree, type } = props;

    const iconBasedOnStatus = (status: string) => {
        if (status === "success") return <img src={SuccessIcon} width="24px" />;
        else if (status == "error") return <img src={ErrorIcon} width="24px" />;
        else if (status == "no access") return <LockIcon />;
        else if (status == "warning") return <img src={WarningIcon} width="24px" />;
        else return <img src={InfoIcon} width="24px" />;
    };

    return (
        <DialogBox
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                display="flex"
                alignItems="center"
                sx={{
                    padding: "15px",
                    paddingLeft: "20px",
                    paddingBottom: "5px",
                    color: "black",
                    width: "100%",
                }}
            >
                {iconBasedOnStatus(type)} &nbsp; {title}
            </Box>
            <IconButton
                aria-label="close"
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
                onClick={onClose}
            >
                <CloseIcon />
            </IconButton>
            <DialogBoxContent>
                <Box
                    sx={{
                        display: "block",
                        flexDirection: "column",
                        justifyContent: "left",
                        textAlign: "left",
                        paddingLeft: "12px",
                        gap: "24px",
                    }}
                >
                    <Box sx={{ paddingInline: "8px", paddingBottom: "20px" }}>{content}</Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "16px",
                    }}
                >
                    <PrimaryButton
                        onClick={onAgree}
                        sx={{ minWidth: "60px" }}
                    >
                        Yes
                    </PrimaryButton>
                    <PrimaryButton
                        onClick={onDisagree}
                        sx={{ minWidth: "60px" }}

                    >
                        No
                    </PrimaryButton>
                </Box>
            </DialogBoxContent>
        </DialogBox>
    );
}
